import { defineStore } from 'pinia'

export const useLoaderStore = defineStore('loaderStore', {
  state: () => ({
    showLoader: false,
    isLoading: false,
  }),
  actions: {
    setIsLoading(isLoading) { this.isLoading = isLoading },
    show() {
      this.showLoader = true
    },
    hide() {
      this.showLoader = false
    },
  },
})
